import { render, staticRenderFns } from "./LastSimulation.vue?vue&type=template&id=6466f744&scoped=true"
import script from "./LastSimulation.vue?vue&type=script&lang=js"
export * from "./LastSimulation.vue?vue&type=script&lang=js"
import style0 from "./LastSimulation.vue?vue&type=style&index=0&id=6466f744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466f744",
  null
  
)

export default component.exports